publishingApp.controller('publishersController', ['$scope', '$rootScope', '$state', '$uibModal', 'dbData', '$log', '$resource', 'DTOptionsBuilder', 'DTColumnDefBuilder', '$cookies', '$http', '$debounce', 'fileUpload', function ($scope, $rootScope, $state, $uibModal, dbData, $log, $resource, DTOptionsBuilder, DTColumnDefBuilder, $cookies, $http, $debounce, fileUpload) {
    $scope.isArray = angular.isArray;
    /** ALL PUBLISHERS **/
    if ($state.current.name === "publishers") {

        // PERMISSIONS CHECK
        // This page should be only available to users with organization-edit permission
        if (!$rootScope.userCan($rootScope.user.permissions, ['organization-edit'])) {
            $rootScope.pushAlerts("Sorry, you have no permission to access this");
            $log.info("Permission error: required ['organization-edit'], state: " + $state.current.name + ", function: publishersController");
            $state.go('index');
        }

        $scope.currentCourses = [];
        $scope.searchQuery = '';

        $scope.filterPublishersBy = {
            'ids': '',
            'location': '',
            'name': '',
            'user': '',
        };

        $scope.publishersTable = this;
        $scope.publishersTable.publishers = [];

        $scope.publishersTable.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('tr');

        $scope.publishersTable.dtColumnDefs = [
            // Columns starting at 0
            DTColumnDefBuilder.newColumnDef(7).notSortable()
        ];

        $scope.pcmsTable = this;
        $scope.pcmsTable.pcms = [];

        // $scope.pcmsTable.dtOptions = DTOptionsBuilder.newOptions()
        //     .withDOM('tr');

        $scope.pcmsTable.dtColumnDefs = [
            // Columns starting at 0
            DTColumnDefBuilder.newColumnDef(4).notSortable()
        ];

        /**
         * Soft delete Publisher
         *
         * @param publisher_id
         * @param publisherName
         */
        $scope.deletePublisher = function (publisherId, publisherName) {
            $uibModal.open({
                templateUrl: '../angular/views/modals/publishers/confirm-modal.html',
                scope: $scope,
                controller: function ($scope, $uibModalInstance) {

                    $scope.deletePublisherModal = true;
                    $scope.publisherId = publisherId;
                    $scope.publisherName = publisherName;

                    $scope.cancelModal = function () {
                        $uibModalInstance.dismiss('cancel');
                        $scope.deletePublisherModal = false;
                    };

                    $scope.submitModal = function () {
                        $('.page-loading').removeClass('hidden');

                        dbData.delete("api/publishers/" + publisherId).then(
                            function (response) {
                                $('.page-loading').addClass('hidden');
                            },
                            function (error) {
                                if (error.data.hasOwnProperty("error")) {
                                    $rootScope.pushAlerts("Error : " + error.data.error);
                                } else {
                                    $rootScope.pushAlerts("Error while loading publishers");
                                }
                                $log.error('An error occurred: ' + error.message);
                                $('.page-loading').addClass('hidden');
                            }
                        );

                        $uibModalInstance.dismiss('cancel');
                        $scope.deletePublisherModal = false;
                    };
                }
            });
        };

        /**
         * Suspend the Publisher
         *
         * @param publisher_id
         * @param publisherName
         */
        $scope.suspendPublisher = function (publisherId, publisherName) {
            $uibModal.open({
                templateUrl: '../angular/views/modals/publishers/confirm-modal.html',
                scope: $scope,
                controller: function ($scope, $uibModalInstance) {

                    $scope.suspendPublisherModal = true;
                    $scope.publisherId = publisherId;
                    $scope.publisherName = publisherName;

                    $scope.cancelModal = function () {
                        $uibModalInstance.dismiss('cancel');
                        $scope.suspendPublisherModal = false;
                    };

                    $scope.submitModal = function () {
                        $('.page-loading').removeClass('hidden');

                        dbData.put("api/publishers/" + publisherId + "/dormant").then(
                            function (response) {
                                getPublishers();
                                $rootScope.pushAlerts("Publisher was successfully suspended");
                                $('.page-loading').addClass('hidden');
                            },
                            function (error) {
                                if (error.data.hasOwnProperty("error")) {
                                    $rootScope.pushAlerts("Error: " + error.data.error);
                                } else {
                                    $rootScope.pushAlerts("Error while marking publisher dormant");
                                }
                                $log.error('An error occurred: ' + error.message);
                                $('.page-loading').addClass('hidden');
                            }
                        );

                        $uibModalInstance.dismiss('cancel');
                        $scope.suspendPublisherModal = false;
                    };
                }
            });
        };

        $scope.unsuspendPublisher = function (publisherId, publisherName) {
            $uibModal.open({
                templateUrl: '../angular/views/modals/publishers/confirm-modal.html',
                scope: $scope,
                controller: function ($scope, $uibModalInstance) {

                    $scope.unsuspendPublisherModal = true;
                    $scope.publisherId = publisherId;
                    $scope.publisherName = publisherName;

                    $scope.cancelModal = function () {
                        $uibModalInstance.dismiss('cancel');
                        $scope.unsuspendPublisherModal = false;
                    };

                    $scope.submitModal = function () {
                        $('.page-loading').removeClass('hidden');

                        dbData.put("api/publishers/" + publisherId + "/unsuspend").then(
                            function (response) {
                                $('.page-loading').addClass('hidden');
                                $rootScope.pushAlerts("Publisher was successfully unsuspended");
                                getPublishers();
                            },
                            function (error) {
                                if (error.data.hasOwnProperty("error")) {
                                    $rootScope.pushAlerts("Error: " + error.data.error);
                                } else {
                                    $rootScope.pushAlerts("Error while trying to unsuspend publisher");
                                }
                                $log.error('An error occurred: ' + error.message);
                                $('.page-loading').addClass('hidden');
                            }
                        );

                        $uibModalInstance.dismiss('cancel');
                        $scope.unsuspendPublisherModal = false;
                    };
                }
            });
        };

        var getPCMs = function () {
            dbData.get('/api/users?role=publishing-content-manager').then(
                function (response) {
                    $scope.pcmsTable.pcms = response.data;
                },
                function (error) {
                }
            );
        };

        /**
         * Get list of publishers
         * @param page {number} page to be fetched
         */
        var getPublishers = function (page) {
            var page = page || 1;
            generateSearchQuery();

            setTimeout(function () {
                $scope.publishersTable.publishers = [];

                dbData.get('api/publishers' + $scope.searchQuery + '&page=' + page).then(
                    function (response) {
                        $scope.publishersTable.publishers = response.data.data;

                        if (response.data.total > response.data.per_page) {
                            generatePagination(response.data.total, response.data.per_page, response.data.current_page, '/api/publishers' + $scope.searchQuery);
                            $('#pagination').show();
                        } else {
                            $('#pagination').hide();
                        }
                    },
                    function (error) {
                        if (error.data.hasOwnProperty("error")) {
                            $rootScope.pushAlerts("Error : " + error.data.error);
                        } else {
                            $rootScope.pushAlerts("Error while loading publishers");
                        }
                        $log.error("An error has occurred: " + error);
                    }
                );
            }, 0);
        };

        getPublishers();

        if ($rootScope.userCan($rootScope.user.permissions, ['user-manage-contractors'])) {
            getPCMs();
        }

        /**
         * Generate pagination
         * @param totalItems {number} total items in set
         * @param itemsPerPage {number} items displayed per page
         * @param page {number} page to be fetched
         * @param url {string}
         * @returns {undefined}
         */

        function generatePagination(totalItems, itemsPerPage, page, url) {

            if (totalItems > itemsPerPage) {
                $('#pagination').pagination({
                    items: totalItems,
                    itemsOnPage: itemsPerPage,
                    pages: Math.ceil(totalItems / itemsPerPage),
                    cssStyle: 'light-theme',
                    currentPage: page,
                    hrefTextPrefix: url + "?page=",
                    onPageClick: function (pageNumber, e) {
                        e.preventDefault();
                        getPublishers(pageNumber);
                    }
                });
            }

            return undefined;
        };

        /**
         * Generate search query for the filters
         */
        function generateSearchQuery() {
            setTimeout(function () {

                // Reset search query
                $scope.searchQuery = '';

                for (var property in $scope.filterPublishersBy) {
                    switch (property) {
                        case "ids":
                            angular.forEach($scope.filterPublishersBy.ids.trim().split(","), function (value, key) {
                                if (value !== "") {
                                    $scope.searchQuery += "&ids[]=" + value;
                                }
                            });
                            break;
                        case "location":
                            $scope.searchQuery += '&location_like=' + $scope.filterPublishersBy[property];
                            break;
                        case "name":
                            $scope.searchQuery += '&name_like=' + $scope.filterPublishersBy[property];
                            break;
                        case "user":
                            $scope.searchQuery += '&author_name=' + $scope.filterPublishersBy[property];
                            break;
                    }
                }

                // Replace first & with ?
                $scope.searchQuery = $scope.searchQuery.replace("&", "?");

            }, 0);
        };

        // Save filters data to local storage
        $('body').on('keyup', 'input#search_by_name, input#search_by_user, input#search_by_location, input#search_by_ids', function () {
            $debounce(debounceKeyup, 500, false);
        });

        var debounceKeyup = function () {
            if ($('input#search_by_ids')[0].value.length >= 0) {
                $scope.filterPublishersBy.ids = $('input#search_by_ids')[0].value;
            }

            if ($('input#search_by_location')[0].value.length >= 0) {
                $scope.filterPublishersBy.location = $('input#search_by_location')[0].value;
            }

            if ($('input#search_by_name')[0].value.length >= 0) {
                $scope.filterPublishersBy.name = $('input#search_by_name')[0].value;
            }

            if ($('input#search_by_user')[0].value.length >= 0) {
                $scope.filterPublishersBy.user = $('input#search_by_user')[0].value;
            }

            // Make a call
            getPublishers();
        };

        $scope.$on('$destroy', function () {
            $(document.body).off('search', '#filter-box > .input-box input');
            $('body').off('search', '.search-filters--publishers > .input-box input');
            $('body').off('keyup', 'input#search_by_name, input#search_by_user, input#search_by_location, input#search_by_ids');
            $('body').off('change', '#search_by_period_from');
            $('body').off('keyup', 'input#search_by_ids');
        });

        // Clear filters when input cross is pressed
        $('body').on('search', '.search-filters--publishers > .input-box input', function () {
            if ($(this)[0].id == 'search_by_ids') {
                $scope.filterPublishersBy.ids = '';
            }

            if ($(this)[0].id == 'search_by_location') {
                $scope.filterPublishersBy.location = '';
            }

            if ($(this)[0].id == 'search_by_name') {
                $scope.filterPublishersBy.name = '';
            }

            if ($(this)[0].id == 'search_by_user') {
                $scope.filterPublishersBy.user = '';
            }

            // Make a call
            getPublishers();
        });
    }

    /** USERS ASSOCIATED WITH A PUBLISHER **/
    if ($state.current.name === "publisher-users" || $state.current.name === "organization") {

        window.scrollTo(0, 0);

        $scope.newAuthor = {};
        $scope.newAuthor.role = "external-editor";
        $scope.paymentMethods = [/*{"name": "Paypal", "code": "pay_pal"},*/{ "name": "Bank Transfer", "code": "bank" }];

        // PERMISSIONS CHECK
        // This page should be only available to users with organization-show permission
        if (!$rootScope.userCan($rootScope.user.permissions, ['organization-show'])) {
            $rootScope.pushAlerts("Sorry, you have no permission to access this");
            $log.info("Permission error: required ['organization-show'], state: " + $state.current.name + ", function: publishersController");
            $state.go('index');
        }

        if ($state.params.id != $rootScope.user.publisher_id) {
            if (!$rootScope.userCan($rootScope.user.permissions, ['publisher-manage-pam'])) {   // Not SA or PCM
                $rootScope.pushAlerts("Sorry, you have no permission to access this");
                $log.info("Permission error: required ['publisher-manage-pam'], state: " + $state.current.name + ", function: publishersController");
                $state.go('index');
            }
        }

        // Take publisher id from $state
        $scope.publisherId = $state.params.id;
        $scope.publisher = {};

        if ($state.current.name === "organization") {
            dbData.get('api/publishers/' + $scope.publisherId).then(
                function (response) {
                    $scope.publisher = response.data;

                    // Get Selected Payment Method
                    var currentPaymentService = $scope.publisher.publisher_payout_services.filter(function (payoutService) {
                        return payoutService.id === $scope.publisher.selected_payout_service_id;
                    })[0];

                    $scope.publisher.service_type = currentPaymentService.service_type;
                    $scope.publisher.country_id = currentPaymentService.country_id;

                    if ($scope.publisher.selected_payout_service_id === null) {
                        dbData.get('api/paypal/merchant-info').then(
                            function (response) {
                                $scope.payPalMerchantInfo = response.data;
                            },
                            function (error) {
                                if (error.data.hasOwnProperty("error")) {
                                    $rootScope.pushAlerts("Error : " + error.data.error);
                                } else {
                                    $rootScope.pushAlerts("Error while loading PayPal  Merchant Info");
                                }
                                $log.error("An error has occurred: " + error);
                            }
                        );
                    }

                },
                function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while loading publishers");
                    }
                    $log.error("An error has occurred: " + error);
                }
            );

            $scope.countriesList = [];
            dbData.get('api/countries').then(
                function (response) {
                    $scope.countriesList = response.data;
                });

            $scope.stats = {};
            dbData.get('api/publishers/' + $scope.publisherId + '/statistics').then(
                function (response) {
                    $scope.stats = response.data;
                },
                function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while loading publishers statistics");
                    }
                    $log.error("An error has occurred: " + error);
                }
            );

            $scope.country_id = $scope.publisher.country_id;
        } else {
            dbData.get('api/publishers/' + $scope.publisherId).then(
                function (response) {
                    $scope.publisher = response.data.name;
                },
                function (error) {
                    $log.error("An error has occurred: " + error);
                }
            );
        }

        $scope.roles = [];
        $scope.authors = [];
        $scope.users = [];
        $scope.selectedUser = '';

        $scope.publishersUsersTable = this;

        if ($state.current.name === "publisher-users") {
            $scope.publishersUsersTable.dtColumnDefs = [
                // Columns starting at 0
                DTColumnDefBuilder.newColumnDef(3).notSortable(),
                DTColumnDefBuilder.newColumnDef(4).notSortable().withClass('custom-width'),
                DTColumnDefBuilder.newColumnDef(5).notSortable(),
            ];
        }

        if ($state.current.name === "organization") {
            // Env is used to hide alison users from display on production environment
            $scope.env = document.getElementById('main-doc').dataset.env;

            if ($rootScope.userCan($rootScope.user.permissions, ['user-manage-roles'])) {
                $scope.publishersUsersTable.dtColumnDefs = [
                    // Columns starting at 0
                    DTColumnDefBuilder.newColumnDef(3).notSortable(),
                    DTColumnDefBuilder.newColumnDef(4).notSortable().withClass('custom-width'),
                ];
            } else {
                $scope.publishersUsersTable.dtColumnDefs = [
                    // Columns starting at 0
                    DTColumnDefBuilder.newColumnDef(3).notSortable(),
                ];
            }

            $scope.editPublisherData = function (section) {
                var payload = {},
                    endpoint = "",
                    message = "";

                switch (section) {
                    case 'publisher-details':
                        payload = {
                            'tax_number': $scope.publisher.tax_number,
                            'business_registration_id': $scope.publisher.business_registration_id,
                            'business_name': $scope.publisher.business_name,
                            'street': $scope.publisher.business_address.street,
                            'city': $scope.publisher.business_address.city,
                            'state': $scope.publisher.business_address.state,
                            'zip_code': $scope.publisher.business_address.zip_code,
                            'country_id': $scope.publisher.business_address.country_id,
                        };

                        endpoint = "business-details";
                        message = "Business Details";

                        break;

                    case 'bank-details--payment-method':
                        payload = {
                            'service_type': $scope.publisher.service_type,
                            'country_id': $scope.publisher.country_id,
                        };

                        endpoint = "payment-method";
                        message = "Payment Method";

                        break;

                    case 'bank-details--bank-data':
                        payload = {
                            'bank_name': $scope.publisher.banking_details.bank_name,
                            'address': $scope.publisher.banking_details.address,
                            'account_fullname': $scope.publisher.banking_details.account_fullname,
                            'iban': $scope.publisher.banking_details.iban,
                            'account_number': $scope.publisher.banking_details.account_number,
                            'swift_bic_code': $scope.publisher.banking_details.swift_bic_code,
                        };

                        endpoint = "banking-details";
                        message = "Bank Details";

                        break;

                    default:
                        return;
                }

                dbData.patch('api/publishers/' + $scope.publisherId + '/' + endpoint, JSON.stringify(payload)).then(function (response) {
                    $rootScope.pushAlerts('Publisher ' + message + ' saved successfully');
                }, function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts('Error while saving Publisher ' + message);
                    }
                    $log.error(error);
                });
            }

            function getMetabaseReport() {
                dbData.get('/api/publishers/' + $rootScope.user.publisher_id + '/dashboard/44',
                    {
                        headers: {
                            'Authorization': 'Bearer ' + $cookies.get('access_token_' + document.getElementById('main-doc').dataset.env)
                        }
                    }).then(function (response) {
                        console.log(response.data);

                        $('iframe').remove();
                        var iframe = document.createElement("iframe");
                        var embeddingContainer = document.getElementById('embeddingContainer');

                        iframe.style.height = '350px';
                        iframe.style.width = '100%';
                        iframe.setAttribute("src", response.data);

                        embeddingContainer.appendChild(iframe);
                    },
                        function (error) {
                            $('.page-loading').addClass('hidden');
                            $rootScope.pushAlerts('Error while loading report');
                        }
                    );
            }

            if (!$rootScope.user.roles.includes('external-editor')) {
                getMetabaseReport();
            }
        }

        $('.page-loading').removeClass('hidden');

        dbData.get('api/publishers/' + $scope.publisherId + '/users').then(
            function (response) {
                $scope.users = response.data;

                $scope.publishersUsersTable.dtOptions = {
                    paginationType: 'simple_numbers',
                    displayLength: 50,
                    dom: ($scope.users > 50) ? 'ftirp' : 'ftir',
                };

                dbData.get('api/roles').then(
                    function (response) {
                        var rolesFromResponse = [];
                        var restrictedRoles = [];
                        for (var i = 0; i < response.data.length; i++) {
                            rolesFromResponse.push(
                                {
                                    id: response.data[i].id,
                                    code: response.data[i].name,
                                    display_name: response.data[i].display_name
                                }
                            );
                        }

                        if (!$rootScope.user.roles.includes('super-admin')) {
                            restrictedRoles.push('super-admin', 'publishing-content-manager', 'key-publisher-manager', 'financial-controller')
                        }
                        if (!$rootScope.userCan($rootScope.user.permissions, ['publisher-manage-pam'])) {
                            restrictedRoles.push('publishing-account-manager')
                        }
                        if ($rootScope.userCan($rootScope.user.permissions, ['user-manage-roles'], ['course-published-full-reedit'])) {
                            restrictedRoles.push('alison-editor', 'view-only');
                        }

                        rolesFromResponse = rolesFromResponse.reduce(function (result, currentValue) {
                            if (!restrictedRoles.includes(currentValue['code'])) {
                                result.push(currentValue);
                            }
                            return result;
                        }, []);

                        $scope.roles = rolesFromResponse;
                    }, function (error) {
                        if (error.data.hasOwnProperty("error")) {
                            $rootScope.pushAlerts("Error : " + error.data.error);
                        } else {
                            $rootScope.pushAlerts("Error while loading roles");
                        }
                        $log.error("An error occurred: " + error);
                        $('.page-loading').addClass('hidden');
                    });
            },
            function (error) {
                if (error.data.hasOwnProperty("error")) {
                    $rootScope.pushAlerts("Error : " + error.data.error);
                } else {
                    $rootScope.pushAlerts("Error while loading publisher users");
                }
                $log.error("An error has occurred: " + error);
                $('.page-loading').addClass('hidden');
            }
        );

        /**
         * Login as selected user
         *
         * @param userEmail - selected user email
         * @param publisherId - publisher associated with that user
         */
        $scope.loginAsUser = function (userEmail, publisherId) {
            var payload = {
                "email": userEmail,
                "publisher_id": publisherId
            },
                request = {
                    method: 'POST',
                    url: '/auth/login-with-user',
                    data: JSON.stringify(payload)
                };
            $http(request).then(
                function (response) {
                    if (response.data.success) {
                        $rootScope.pushAlerts("Logging in as " + userEmail);
                        location.href = "/"; // Don't use $state here
                    }
                },
                function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while signing in as an user");
                    }
                    $log.error(error.data);
                }
            );
        };

        $scope.newOrganizationAdmin = {};

        $scope.changeOrganizationAdmin = function () {
            var payload = JSON.stringify({ user_id: parseInt($scope.newOrganizationAdmin.user.id) });

            $('.page-loading').removeClass('hidden');

            dbData.put('api/publishers/' + $scope.publisherId + '/change-organization-admin', payload).then(
                function (response) {
                    $('.page-loading').addClass('hidden');
                    $rootScope.pushAlerts($scope.newOrganizationAdmin.user.fullName + ' had been successfully assigned with Organization Admin role.');
                    setTimeout(function () {
                        window.location.reload();
                    }, 500);
                }, function (error) {
                    $('.page-loading').addClass('hidden');
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while updating Organization Admin");
                    }
                    $log.error(error.data);
                }
            );
        };

        /**
         * Generate abbreviation of user role
         * @param source
         * @returns {string|string}
         */
        $scope.generateAbbreviation = function (source) {
            var arr = source.split('-');
            var abbreviation = '';
            for (var i = 0; i < arr.length; i++) {
                abbreviation += (arr.length === 1) ? arr[i].substring(0, 2) : arr[i].substring(0, 1);
            }
            return abbreviation;
        };

        /**
         * Check if user already exists in data set
         * @param needle
         * @param haystack
         * @returns {boolean}
         */
        var lookupUser = function (needle, haystack) {
            var found = false;
            for (var i = 0; i < haystack.length; i++) {
                if (haystack[i].email == needle.email) {
                    found = true;
                    break;
                }
            }
            return found;
        };

        /**
         * Highlight active role class
         *
         * @param haystack
         * @param needle
         * @returns {boolean}
         */
        $scope.lookupRole = function (haystack, needle) {
            var found = false;
            for (var i = 0; i < haystack.length; i++) {
                if (haystack[i] == needle) {
                    found = true;
                    break;
                }
            }
            return found;
        };

        // Append new user to the Publisher
        $scope.addUser = function () {
            if (lookupUser($scope.newAuthor, $scope.users)) {
                $rootScope.pushAlerts('This author is already assigned to your organization.');
                $scope.newAuthor.email = '';
                return;
            }
            var payload = {
                "email": $scope.newAuthor.email,
                "role_name": $scope.newAuthor.role,
            };

            dbData.post('api/publishers/' + $scope.publisherId + '/users', JSON.stringify(payload)).then(
                function (response) {
                    $rootScope.pushAlerts("Author was successfully assigned to your organization");
                    setTimeout(function () {
                        window.location.reload();
                    }, 500);
                }, function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while attaching an user");
                    }
                    $log.error(error);
                }
            );
        };

        // Suspend the user
        $scope.suspendUser = function (userId, userName, userEmail) {
            $uibModal.open({
                templateUrl: '../angular/views/modals/publishers/confirm-modal.html',
                scope: $scope,
                controller: function ($scope, $uibModalInstance) {

                    $scope.suspendUserModal = true;
                    $scope.userId = parseInt(userId);
                    $scope.userName = userName;
                    $scope.userEmail = userEmail;

                    $scope.cancelModal = function () {
                        $uibModalInstance.dismiss('cancel');
                        $scope.suspendUserModal = false;
                    };

                    $scope.submitModal = function () {
                        $('.page-loading').removeClass('hidden');


                        dbData.put('api/users/' + $scope.userId + '/suspend').then(
                            function (response) {
                                $rootScope.pushAlerts("User " + userName + " (" + userEmail + ") successfully suspended");
                                setTimeout(function () {
                                    window.location.reload();
                                }, 500);
                            }, function (error) {
                                if (error.data.hasOwnProperty("error")) {
                                    $rootScope.pushAlerts("Error : " + error.data.error);
                                } else {
                                    $rootScope.pushAlerts("Error while suspending the user");
                                }
                                $log.error(error.data);
                            }
                        );

                        $uibModalInstance.dismiss('cancel');
                        $scope.suspendUserModal = false;
                    };
                }
            });
        };

        // Unsuspend the user
        $scope.unsuspendUser = function (userId, userName, userEmail) {
            $uibModal.open({
                templateUrl: '../angular/views/modals/publishers/confirm-modal.html',
                scope: $scope,
                controller: function ($scope, $uibModalInstance) {

                    $scope.unsuspendUserModal = true;
                    $scope.userId = parseInt(userId);
                    $scope.userName = userName;
                    $scope.userEmail = userEmail;

                    $scope.cancelModal = function () {
                        $uibModalInstance.dismiss('cancel');
                        $scope.unsuspendUserModal = false;
                    };

                    $scope.submitModal = function () {
                        $('.page-loading').removeClass('hidden');

                        dbData.put('api/users/' + $scope.userId + '/unsuspend').then(
                            function (response) {
                                $rootScope.pushAlerts("User " + userName + " (" + userEmail + ") successfully unsuspended");
                                setTimeout(function () {
                                    window.location.reload();
                                }, 500);
                            }, function (error) {
                                if (error.data.hasOwnProperty("error")) {
                                    $rootScope.pushAlerts("Error : " + error.data.error);
                                } else {
                                    $rootScope.pushAlerts("Error while unsuspending the user");
                                }
                                $log.error(error.data);
                            }
                        );

                        $uibModalInstance.dismiss('cancel');
                        $scope.unsuspendUserModal = false;
                    };
                }
            });
        };

        // Detatch user from a publisher
        $scope.detachUser = function (userId, userName, userEmail) {
            $uibModal.open({
                templateUrl: '../angular/views/modals/publishers/confirm-modal.html',
                scope: $scope,
                controller: function ($scope, $uibModalInstance) {

                    $scope.detachUserModal = true;
                    $scope.publisherId = parseInt($state.params.id);
                    $scope.userId = parseInt(userId);
                    $scope.userName = userName;
                    $scope.userEmail = userEmail;

                    $scope.cancelModal = function () {
                        $uibModalInstance.dismiss('cancel');
                        $scope.detachUserModal = false;
                    };

                    $scope.submitModal = function () {
                        $('.page-loading').removeClass('hidden');

                        dbData.delete('api/publishers/' + $scope.publisherId + '/users/' + $scope.userId).then(
                            function (response) {
                                $rootScope.pushAlerts("Author " + userName + " (" + userEmail + ") successfully removed from your organization");
                                setTimeout(function () {
                                    window.location.reload();
                                }, 500);
                            }, function (error) {
                                if (error.data.hasOwnProperty("error")) {
                                    $rootScope.pushAlerts("Error : " + error.data.error);
                                } else {
                                    $rootScope.pushAlerts("Error while detaching an user");
                                }
                                $log.error(error.data);
                            }
                        );

                        $uibModalInstance.dismiss('cancel');
                        $scope.detachUserModal = false;
                    };
                }
            });
        };

        /**
         * Change user role
         *
         * @param currentRoles {object} array of user current roles
         * @param newRole {string} new role to be added/removed
         */
        $scope.changeUserRole = function (currentRoles, newRole, userId, $event) {
            var payload = {
                "roles": [],
                "publisher_id": parseInt($scope.publisherId),
            };

            angular.forEach(currentRoles, function (value, key) {
                payload.roles.push(value);
            });

            if (payload.roles.includes(newRole)) {
                // remove role
                payload.roles.splice(payload.roles.indexOf(newRole), 1);
            } else {
                // add role
                payload.roles.push(newRole);
            }

            $('.page-loading').removeClass("hidden");

            dbData.patch('api/users/' + userId + '/roles', JSON.stringify(payload)).then(
                function (response) {
                    // Hide spinner
                    $('.page-loading').addClass("hidden");
                    location.reload();
                    return false;
                },
                function (error) {
                    // Hide spinner
                    $('.page-loading').addClass("hidden");
                }
            );
        };
    }

    /** CREATE PUBLISHER **/
    if ($state.current.name === "create-publisher") {

        // PERMISSIONS CHECK
        // This page should be only available to users with organization-create permission
        if (!$rootScope.userCan($rootScope.user.permissions, ['organization-create'])) {
            $rootScope.pushAlerts("Sorry, you have no permission to access this");
            $log.info("Permission error: required ['organization-create'], state: " + $state.current.name + ", function: publishersController");
            $state.go('index');
        }

        $scope.action = "Create";
        $scope.publisher = {
            tax_number: "",
            business_registration_id: "",
            business_name: "",
            owned_by_alison: false,
        };
        $scope.countriesList = [];

        dbData.get('api/countries').then(
            function (response) {
                $scope.countriesList = response.data;
            });
        // Create a new publisher
        $scope.createPublisher = function () {
            // Add spinner
            $('.page-loading').removeClass("hidden");

            // Prepare payload
            var payload = {
                "name": $scope.publisher.name,
                "location": $scope.publisher.location,
                "background": $scope.publisher.background,
                "expertise": $scope.publisher.expertise,
                "owned_by_alison": $scope.publisher.owned_by_alison,
                "short_bio": $scope.publisher.short_bio,
                "services": $scope.publisher.services,
                "cert_admin_fee": $scope.publisher.cert_admin_fee,
                "cert": $scope.publisher.cert,
                "adsense_admin_fee": $scope.publisher.adsense_admin_fee,
                "adsense": $scope.publisher.adsense,
                "meta_title": $scope.publisher.meta_title,
                "meta_desc": $scope.publisher.meta_desc,
                "keywords": $scope.publisher.keywords,
            };

            dbData.post('api/publishers', JSON.stringify(payload)).then(
                function (response) {
                    setTimeout(function () {
                        $state.go("publishers");
                    }, 500);

                    $rootScope.pushAlerts("Publisher created successfully");
                    $('.page-loading').addClass("hidden");
                },
                function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while creating a publisher");
                    }
                    $log.error("An error occurred: " + JSON.stringify(error));

                    // Hide spinner
                    $('.page-loading').addClass("hidden");
                }
            );
        };
    }

    /** EDIT PUBLISHER **/
    if ($state.current.name === "edit-publisher") {

        // PERMISSIONS CHECK
        // This page should be only available to users with organization-edit permission
        if (!$rootScope.userCan($rootScope.user.permissions, ['organization-edit'])) {
            $rootScope.pushAlerts("Sorry, you have no permission to access this");
            $log.info("Permission error: required ['organization-edit'], state: " + $state.current.name + ", function: publishersController");
            $state.go('index');
        }

        var allPublisherTypes = [];

        // $scope.countriesList = [];
        // dbData.get('api/countries').then(
        //     function (response) {
        //         $scope.countriesList = response.data;
        //     });

        $scope.kpmsTable = this;
        $scope.kpmsTable.currentKpm = [];
        $scope.kpmsTable.kpms = [];

        $scope.pamsTable = this;
        $scope.pamsTable.pams = [];
        $scope.pamsTable.availalblePams = [];
        $scope.pamsTable.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('tr');

        $scope.kpmsTable.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('tr');

        $scope.pamsTable.dtColumnDefs = [
            // Columns starting at 0
            DTColumnDefBuilder.newColumnDef(3).notSortable()
        ];

        $scope.action = "Edit";
        $scope.publisher = {};
        $scope.publisherId = $state.params.id;

        $scope.currentPublisherTypeName = '';
        $scope.targetPublisherTypeName = '';
        $scope.publisherType = { id: 0 };
        $scope.selectablePublisherTypes = [];

        $scope.applicationData = [];
        $scope.selectedFlow = 'assisted_course_creator';
        $scope.applicationFlows = [{ name: 'Assisted Course Creator', form_identifier: 'assisted_course_creator' }, { name: 'Course Creator', form_identifier: 'course_creator' }];

        dbData.get('api/publisher-types').then(
            function (response) {
                allPublisherTypes = response.data;
                $scope.selectablePublisherTypes = response.data.slice(2, response.data.length);

                $scope.publisherType.id = $scope.selectablePublisherTypes[0].id;

                dbData.get('api/publishers/' + $scope.publisherId).then(
                    function (response) {
                        $scope.publisher = response.data;
                        $scope.kpmsTable.currentKpm = [];

                        if (response.data.key_publisher_manager) {
                            $scope.kpmsTable.currentKpm.push(response.data.key_publisher_manager);
                        }

                        if (response.data.publisher_type_id) {
                            $scope.currentPublisherTypeName = $rootScope.getObjectByPropertyValue(allPublisherTypes, 'id', $scope.publisher.publisher_type_id).name;
                        }

                        if ($rootScope.userCan($rootScope.user.permissions, ['publisher-manage-pam'])) {
                            listPams();
                        }

                        if ($rootScope.userCan($rootScope.user.permissions, ['publisher-manage-kpm'])) {
                            listKpms();
                        }

                        if ($rootScope.userCan($rootScope.user.permissions, ['organization-edit'])) {
                            fetchApplicationData();
                        }


                        if ($('#publisher_type_id option:selected')[0].value.includes('?')) {
                            $('#publisher_type_id option:selected')[0].remove();
                        }
                    },
                    function (error) {
                        $log.error("An error has occurred: " + error);
                    }
                );
            },
            function (error) {
                $log.error("An error has occurred: " + error);
            }
        );

        dbData.getUsers('role=publishing-account-manager').then(function (response) {
            $scope.pamsTable.availalblePams = response.data;
        }, function (error) {
            if (error.data.hasOwnProperty("error")) {
                $rootScope.pushAlerts("Error : " + error.data.error);
            } else {
                $rootScope.pushAlerts("Error while loading publishing account managers");
            }
            $log.error('An error occurred: ' + error.message);
            $('.page-loading').addClass('hidden');
        });

        var listPams = function () {
            dbData.get('api/publishers/' + $scope.publisherId + '/pams').then(
                function (response) {
                    $scope.pamsTable.pams = response.data;
                }, function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while loading publishing account managers");
                    }
                    $log.error('An error occurred: ' + error.message);
                    $('.page-loading').addClass('hidden');
                }
            );
        };

        var listKpms = function () {
            dbData.get('/api/users?role=key-publisher-manager').then(
                function (response) {
                    $scope.kpmsTable.kpms = response.data;
                }, function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while loading contractors");
                    }
                    $log.error('An error occurred: ' + error.message);
                    $('.page-loading').addClass('hidden');
                }
            );
        };

        var fetchApplicationData = function () {
            dbData.get('api/publishers/' + $scope.publisherId + '/application').then(
                function (response) {
                    if (!$.isEmptyObject(response.data)) {
                        $scope.applicationData = response.data;
                    } else {
                        $scope.no_data = "Data unavailable";
                    }
                }, function (error) {
                    $log.error(error);
                    $('.page-loading').fadeOut();
                }
            );
        };

        $scope.changePublisherKpm = function () {
            // Add spinner
            $('.page-loading').removeClass("hidden");

            if ($scope.kpmsTable.currentKpm.length == 0 || $scope.newKpm.id != $scope.kpmsTable.currentKpm[0].id) {
                dbData.post('api/publishers/' + $scope.publisherId + '/kpms/' + $scope.newKpm.id).then(
                    function (response) {
                        $rootScope.pushAlerts("Key Publisher Manager successfully linked to the Publisher");

                        // Reload scope after some delay to show message
                        setTimeout(function () {
                            $state.go($state.current, {}, { reload: true });
                        }, 1500);

                        // Hide spinner
                        $('.page-loading').addClass("hidden");
                    },
                    function (error) {
                        if (error.data.hasOwnProperty("error")) {
                            $rootScope.pushAlerts("Error: " + error.data.error);
                        } else {
                            $rootScope.pushAlerts("Error while linking Key Publisher Manager to the Publisher");
                        }
                        $log.error("An error occurred: " + JSON.stringify(error));

                        // Hide spinner
                        $('.page-loading').addClass("hidden");
                    }
                );
            } else {
                $rootScope.pushAlerts("This Key Publisher Manager is already assigned to this Publisher");
                $('.page-loading').addClass("hidden");
            }
        };

        $scope.linkPam = function () {
            // Add spinner
            $('.page-loading').removeClass("hidden");

            dbData.post('api/publishers/' + $scope.publisherId + '/pams/' + $scope.newPam.id).then(
                function (response) {
                    $rootScope.pushAlerts("Publisher Account Manager successfully linked to the Publisher");

                    // Update FE
                    listPams();

                    // Hide spinner
                    $('.page-loading').addClass("hidden");
                },
                function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error: " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while linking Publisher Account Manager to the Publisher");
                    }
                    $log.error("An error occurred: " + JSON.stringify(error));

                    // Hide spinner
                    $('.page-loading').addClass("hidden");
                }
            );
        };

        $scope.unlinkPam = function (pamId) {
            dbData.delete('api/publishers/' + $scope.publisherId + '/pams/' + pamId).then(
                function (response) {
                    $rootScope.pushAlerts("Publisher Account Manager successfully un-linked from Publisher");

                    // Remove from scope to avoid need for updating the scope via another get call
                    $scope.pamsTable.pams = $rootScope.removeFromScope($scope.pamsTable.pams, 'id', pamId);
                }, function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while un-linking Publisher Account Manager from the Publisher");
                    }
                    $log.error('An error occurred: ' + error.message);
                    $('.page-loading').addClass('hidden');
                }
            );
        };

        // Update publisher details
        $scope.updatePublisher = function () {
            // Add spinner
            $('.page-loading').removeClass("hidden");

            // Prepare payload
            var payload = {
                "id": $scope.publisher.id,
                "name": $scope.publisher.name,
                "slug": $scope.publisher.slug,
                "location": $scope.publisher.location,
                "background": $scope.publisher.background,
                "expertise": $scope.publisher.expertise,
                "owned_by_alison": $scope.publisher.owned_by_alison,
                "short_bio": $scope.publisher.short_bio,
                "services": $scope.publisher.services,
                "cert_admin_fee": $scope.publisher.cert_admin_fee,
                "cert": $scope.publisher.cert,
                "adsense_admin_fee": $scope.publisher.adsense_admin_fee,
                "adsense": $scope.publisher.adsense,
                "meta_title": $scope.publisher.meta_title,
                "meta_desc": $scope.publisher.meta_desc,
                "keywords": $scope.publisher.keywords,
            };

            // If publisher had already exported course, we forbid slug change, so remove it from payload
            if ($scope.publisher.has_exported_course) {
                delete payload.slug;
            }

            // Execute update
            dbData.patch('api/publishers/' + $scope.publisher.id, JSON.stringify(payload)).then(
                function (response) {
                    $rootScope.pushAlerts("Publisher details updated successfully");
                    if ($rootScope.user.roles.includes('super-admin')) {
                        if (Object.keys(payload2).length > 0) {
                            $scope.updateBusinessDetails(payload2, function () {
                                setTimeout(function () {
                                    $state.go("publishers");
                                }, 1000);
                            })
                        } else {
                            setTimeout(function () {
                                $state.go("publishers");
                            }, 1000);
                        }
                    } else if ($rootScope.user.roles.includes('organization-admin')) {
                        setTimeout(function () {
                            $state.go('organization', { id: $rootScope.user.publisher_id });
                        }, 1000);
                    }

                    $('.page-loading').addClass("hidden");
                },
                function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while updating publisher details");
                    }
                    $log.error("An error occurred: " + JSON.stringify(error));
                    $('.page-loading').addClass("hidden");
                }
            );
        };

        $scope.approvePublisher = function () {
            if ($rootScope.userCan($rootScope.user.permissions, ['organization-edit'])) {

                dbData.put('api/publishers/' + $scope.publisherId + '/setup').then(
                    function (response) {
                        $('.page-loading').addClass('hidden');
                        $rootScope.pushAlerts("Publisher Approved");
                        $state.go($state.current, {}, { reload: true });
                    }, function (error) {
                        if (error.data.hasOwnProperty("error")) {
                            $rootScope.pushAlerts("Error : " + error.data.error);
                        } else {
                            $rootScope.pushAlerts("Error while Approving User");
                        }
                        $log.error("An error occurred: " + JSON.stringify(error));

                        // Hide spinner
                        $('.page-loading').addClass("hidden");
                    }
                );
            }
        };

        $scope.updatePublisherType = function (typeId, fromType) {
            console.log("typeId", typeId, typeof typeId);

            const targetedPublisherName = $rootScope.getObjectByPropertyValue(allPublisherTypes, 'id', typeId).name;

            if (!typeId) {
                $rootScope.pushAlerts("Please select a valid Publisher Type");
                return;
            }

            var payload = {
                "publisher_type_id": parseInt(typeId),
            };

            dbData.patch('api/publishers/' + $scope.publisher.id, JSON.stringify(payload)).then(
                function () {
                    if (typeof ga !== 'undefined') {
                        gtag("event", "Admin Panel", { event_category: "Update Publisher Type", event_label: "Publisher Type", event_value: fromType + '-' + targetedPublisherName });
                    }
                    $rootScope.pushAlerts("Publisher Type successfully changed");
                    $state.go($state.current, {}, { reload: true });
                }, function (error) {
                    $log.error(error);
                    $rootScope.pushAlerts("Error while changing Publisher Type");
                    $('.page-loading').hide();
                }
            );
        };

        $scope.approvePublisherAsAssistedPublisher = function () {
            dbData.put('api/publishers/' + $scope.publisher.id + '/approve').then(
                function () {
                    if (typeof ga !== 'undefined') {
                        gtag("event", "Admin Panel", { event_category: "Update Publisher Flow", event_label: "Publisher Type", event_value: 'assisted_course_creator' });
                    }
                    $rootScope.pushAlerts("Publisher Application successfully approved.");
                    $state.go($state.current, {}, { reload: true });
                }, function (error) {
                    $log.error(error);
                    $rootScope.pushAlerts("Error while approving application.");
                    $('.page-loading').hide();
                }
            );
        };

        // Remove empty option at the beginning
        $scope.$on('ngRepeatFinished', function (temp) {
            $('#publisher_type_id option').each(function (index) {
                if (index === 0) {
                    $(this).remove();
                }
            });
        });
    }

    /** CREATE AND EDIT PUBLISHER **/
    if ($state.current.name === "create-publisher" || $state.current.name === "edit-publisher") {
        $scope.publisherId = $state.params.id;
        $scope.publisherAvatar = {};
        $scope.newPam = {};
        $scope.newKpm = {};
        $scope.pamsList = {};
        var maxFileSize = 2;

        $scope.openImageCrop = function () {
            $uibModal.open({
                templateUrl: '../angular/views/modals/publishers/uploadAvatar.html',
                windowClass: 'pop-up-holder',
                backdrop: false,
                scope: $scope,
                controller: ["$scope", "$uibModalInstance", "$uibModalStack", "$timeout", function ($scope, $uibModalInstance, $uibModalStack, $timeout) {

                    $scope.myImage = '';
                    $scope.myCroppedImage = '';

                    var handleFileSelect = function (evt) {
                        var file = evt.currentTarget.files[0];
                        var reader = new FileReader();
                        reader.onload = function (evt) {
                            $scope.$apply(function ($scope) {
                                $scope.myImage = evt.target.result;
                            });
                        };
                        reader.readAsDataURL(file);
                    };

                    $timeout(function () {
                        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
                    }, 1000, false);

                    console.log($scope.myCroppedImage);

                    $scope.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                    $scope.submitModal = function () {
                        var base64ImageContent = $scope.myCroppedImage.replace(/^data:image\/(png|jpg);base64,/, "");
                        var blob = base64ToBlob(base64ImageContent, 'image/jpg');

                        var filesize = ((blob.size / 1024) / 1024).toFixed(4); // MB

                        if (filesize <= maxFileSize) {
                            var formData = new FormData();
                            formData.set('avatar', blob, 'f1.jpg');

                            $('.page-loading').removeClass('hidden');

                            var request = {
                                method: 'POST',
                                url: 'api/publishers/' + $scope.publisherId + '/avatar',
                                data: formData,
                                headers: {
                                    'Content-Type': undefined
                                }
                            };

                            // SEND THE FILES.
                            $http(request)
                                .success(function (response) {
                                    $rootScope.pushAlerts("File successfully uploaded");
                                    $('.page-loading').addClass('hidden');

                                    $state.go($state.current, {}, { reload: true });
                                })
                                .error(function (error) {
                                    if (error.data.hasOwnProperty("error")) {
                                        $rootScope.pushAlerts("Error : " + error.data.error);
                                    } else {
                                        $rootScope.pushAlerts("File upload failed");
                                    }
                                    $('.page-loading').addClass('hidden');
                                }
                                );
                        } else {
                            $rootScope.pushAlerts("File size to large; maximum allowed file size is " + maxFileSize + " MB");
                        }

                        $uibModalInstance.close('cancel');
                    };

                    function base64ToBlob(base64, mime) {
                        mime = mime || '';
                        var sliceSize = 1024;
                        var byteChars = window.atob(base64);
                        var byteArrays = [];

                        for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
                            var slice = byteChars.slice(offset, offset + sliceSize);

                            var byteNumbers = new Array(slice.length);
                            for (var i = 0; i < slice.length; i++) {
                                byteNumbers[i] = slice.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);

                            byteArrays.push(byteArray);
                        }

                        return new Blob(byteArrays, { type: mime });
                    }
                }]
            });
        };

        $scope.getUserApplicationData = function (id, name, applicationData) {
            $uibModal.open({
                templateUrl: '../angular/views/modals/publishers/publisher-application-data.html',
                scope: $scope,
                controller: function ($scope, $uibModalInstance) {
                    $scope.publisher_name = name;
                    $scope.publisher_data = applicationData;
                    $scope.application_status = ["N/A", "Application created", "Training complete", "Test course started", "Test course in review", "Publisher rejected", "Publisher approved", "1st course in review", "1st course approved", "Contract/Bio complete", "1st course live", "Publisher qualified"];
                    $scope.no_data = false;

                    $scope.cancelModal = function () {
                        $uibModalInstance.dismiss('cancel');
                        $scope.deletePublisherModal = false;
                    };

                    $scope.mapQAPLevels = function (input, applicantType) {
                        var output = '';
                        if (applicantType === 'contractor') {
                            switch (input) {
                                case "1":
                                case 1:
                                    output = 'QACC1';
                                    break;
                                case "2":
                                case 2:
                                    output = 'QACC2';
                                    break;
                                case "3":
                                case 3:
                                    output = 'QACC3';
                                    break;
                                default:
                                    output = "N/A";
                            }
                        } else {
                            switch (input) {
                                case "Level 1: Basic Level entitled to gain access to the Alison Publishing Tool and submit a course to review":
                                case "1":
                                case 1:
                                    output = 'QAA1';
                                    break;
                                case "Level 2: Aim to Publish at least one public course on the Alison platform":
                                case "2":
                                case 2:
                                    output = 'QAA2';
                                    break;
                                case "Level 3: Aim to publish at least 5 courses on the main Alison platform and be able to offer/contract my publishing skills to other publishers on a paid basis":
                                case "3":
                                case 3:
                                    output = 'QAA3';
                                    break;
                                default:
                                    output = "N/A";
                            }
                        }

                        return output;
                    };

                    $('body').on('click', '.application-accordion--trigger', function () {
                        $(this).parent().find('.application-accordion--body').slideToggle();
                    });
                }
            });
        };
    }

    /** ALL PUBLISHERS **/
    if ($state.current.name === "contractors") {

        // PERMISSIONS CHECK
        // This page should be only available to users with user-manage-contractors permission
        if (!$rootScope.userCan($rootScope.user.permissions, ['user-manage-contractors'])) {
            $rootScope.pushAlerts("Sorry, you have no permission to access this");
            $log.info("Permission error: required ['user-manage-contractors'], state: " + $state.current.name + ", function: publishersController");
            $state.go('index');
        }

        var pcmId = $state.params.id;
        $scope.pcm = {};

        $scope.contractorsTable = this;
        $scope.contractorsTable.contractors = [];

        $scope.contractorsTable.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('tr');

        $scope.contractorsTable.dtColumnDefs = [
            // Columns starting at 0
            DTColumnDefBuilder.newColumnDef(3).notSortable()
        ];

        $scope.newContractor = {};

        dbData.get('api/users/' + pcmId).then(
            function (response) {
                $scope.pcm = response.data;
            }, function (error) {
                if (error.data.hasOwnProperty("error")) {
                    $rootScope.pushAlerts("Error : " + error.data.error);
                } else {
                    $rootScope.pushAlerts("Error while loading PCM");
                }
                $log.error('An error occurred: ' + error.message);
                $('.page-loading').addClass('hidden');
            }
        );

        var listContractors = function () {
            dbData.get('api/users/' + pcmId + '/contractors').then(
                function (response) {
                    $scope.contractorsTable.contractors = response.data;
                }, function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while loading contractors");
                    }
                    $log.error('An error occurred: ' + error.message);
                    $('.page-loading').addClass('hidden');
                }
            );
        };

        listContractors();

        $scope.linkContractor = function () {
            dbData.post('api/users/' + pcmId + '/contractors/' + $scope.newContractor.id).then(
                function (response) {
                    $rootScope.pushAlerts("Contractor successfully linked with PCM");
                    listContractors();
                },
                function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while linking contractor to PCM");
                    }
                    $log.error('An error occurred: ' + error.message);
                    $('.page-loading').addClass('hidden');
                }
            );
        };

        $scope.unlinkContractor = function (contractorId) {
            dbData.delete('api/users/' + pcmId + '/contractors/' + contractorId).then(
                function (response) {
                    $rootScope.pushAlerts("Contractor successfully un-linked from PCM");

                    // Remove from scope to avoid need for updating the scope via another get call
                    $scope.contractorsTable.contractors = $rootScope.removeFromScope($scope.contractorsTable.contractors, 'id', contractorId);
                }, function (error) {
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while un-linking contractor from PCM");
                    }
                    $log.error('An error occurred: ' + error.message);
                    $('.page-loading').addClass('hidden');
                }
            );
        };
    }

    $scope.updateBusinessDetails = function (payload, callback) {
        if (typeof payload === "undefined" || payload === null) {
            //alert
            return;
        }

        $('.page-loading').removeClass("hidden");

        if (payload.hasOwnProperty('country_id')) {
            // convert country_id to number
            payload.country_id = parseInt(payload.country_id);
        }

        dbData.patch('api/publishers/' + $scope.publisher.id + '/business-details', JSON.stringify(payload)).then(
            function (response) {
                $scope.publisher = response.data;
                if (typeof callback === "undefined") {
                    if (Object.keys(payload).length === 1) {
                        $rootScope.pushAlerts("Country for banking purposes set up successfully");
                    }
                    $('.page-loading').addClass("hidden");
                } else {
                    callback();
                }
            },
            function (error) {
                if (error.data.hasOwnProperty("error")) {
                    $rootScope.pushAlerts("Error : " + error.data.error);
                } else {
                    if (Object.keys(payload).length === 1) {
                        $rootScope.pushAlerts("Error while setting country for banking purposes");
                    }
                }
                // Hide spinner
                $('.page-loading').addClass("hidden");
            }
        );
    }

    const renderDashboard = function (publisherId, dashboardType) {
        var queryParams = new URLSearchParams({
            ending_date: new URLSearchParams(document.location.search).get('ending_date'),
            date_period: new URLSearchParams(document.location.search).get('date_period'),
        });
        var keysForDel = [];
        queryParams.forEach(function (value, key) {
            if (value === 'null') {
                keysForDel.push(key);
            }
        });
        keysForDel.forEach(function (value) {
            queryParams.delete(value);
        });

        dbData.get('/api/publishers/' + publisherId + '/dashboard/' + dashboardType + (queryParams.toString().length !== 0 ? '?' + queryParams.toString() : '')).then(
            function (response) {
                $('iframe').remove();
                var iframe = document.createElement("iframe");
                iframe.style.height = '950px';
                iframe.style.width = '100%';
                iframe.setAttribute("src", response.data);
                var embeddingContainer = document.getElementById('embeddingContainer')
                embeddingContainer.appendChild(iframe);
            },
            function (error) {
                $('.page-loading').addClass('hidden');
            })
    }

    /** COURSES PERFORMANCE PAGE **/
    if ($state.current.name === "report-courses-performance") {
        $scope.publisherId = $state.params.id;
        $scope.searchPublisher = +$scope.publisherId;
        $scope.report = { name: 'Courses Performance' };

        if (typeof ga !== 'undefined') {
            gtag("event", "Page Visit", { event_category: "Report Page Visits", event_label: "Course Performance Page" });
        }

        if ($rootScope.userCan($rootScope.user.permissions, ['dashboard-courses-performance'])) {
            renderDashboard($scope.publisherId, 1);
        } else {
            $rootScope.pushAlerts("Permission error");
            $state.go('index');
        }

        $scope.changePublisherForDashboard = function (id) {
            $scope.publisherId = id;
        }

        $scope.$watch("publisherId", function (newValue, oldValue) {
            if (newValue != oldValue) {
                renderDashboard(newValue, 1);
            }
        });
    }

    /** DASHBOARD FINANCIAL PAGE **/
    if ($state.current.name === "report-financial") {

        $scope.publisherId = $state.params.id;
        $scope.searchPublisher = +$scope.publisherId;
        $scope.report = { name: 'Financial Report' };
        $scope.agreePanel = false;

        if (typeof ga !== 'undefined') {
            gtag("event", "Page Visit", { event_category: "Report Page Visits", event_label: "Financial Report" });
        }

        dbData.get('/api/publishers/' + $scope.publisherId + '/payouts/approval').then(
            function (response) {
                $scope.agreePanel = response.data.isWaitingForPublisherApproval;
                $scope.payoutAmount = response.data.amount;
                console.log('approval', response.data.isWaitingForPublisherApproval);
            }, function (error) {
                if (error.data.hasOwnProperty("error")) {
                    $rootScope.pushAlerts("Error : " + error.data.error);
                } else {
                    $rootScope.pushAlerts("Error while loading approval request");
                }
                $log.error('An error occurred: ' + error.message);
                $('.page-loading').addClass('hidden');
            }
        );

        if ($rootScope.userCan($rootScope.user.permissions, ['dashboard-financial'])) {
            renderDashboard($scope.publisherId, 2);
        } else {
            $rootScope.pushAlerts("Permission error");
            $state.go('index');
        }

        $scope.changePublisherForDashboard = function (id) {
            $scope.publisherId = id;
        }

        $scope.payoutAgreed = function () {
            $scope.payoutApprovedModal = true;

            $uibModal.open({
                templateUrl: '../angular/views/modals/module-manager/confirm-modal.html',
                windowClass: 'pop-up-holder',
                scope: $scope,
                controller: function ($scope, $uibModalInstance) {

                    $scope.prompt = '';
                    $scope.limiter = true;
                    $scope.thisModal = $uibModalInstance;
                    $scope.proceed = function (event) {

                        // Because event is fired twice, we need limiter to allow for single execution
                        if ($scope.limiter) {
                            $scope.submitModal();
                            $scope.limiter = false;
                        }
                    };

                    $scope.cancelModal = function () {
                        $scope.payoutApprovedModal = false;
                        $uibModalStack.dismissAll('dismiss');
                    };

                    $scope.submitModal = function () {
                        dbData.post('/api/publishers/' + $scope.publisherId + '/payouts/approval').then(
                            function (response) {
                                $rootScope.pushAlerts('Payout Agreed');
                                $('#agree-button').parent().fadeOut().remove();

                                $scope.payoutApprovedModal = false;
                                $uibModalStack.dismissAll('dismiss');

                                $('.page-loading').addClass('hidden');
                            }, function (error) {
                                $scope.payoutApprovedModal = false;
                                $uibModalStack.dismissAll('dismiss');
                            }
                        );
                    }
                }
            });
        }

        $scope.$watch("publisherId", function (newValue, oldValue) {
            if (newValue != oldValue) {
                renderDashboard(newValue, 2);
            }
        });
    }

    /** PUBLISHER PAYOUTS TABLE **/
    if ($state.current.name === "publishers-payouts") {
        // PERMISSIONS CHECK
        // This page should be only available to users with payouts-manage (SA and FC roles) permission
        if (!$rootScope.userCan($rootScope.user.permissions, ['payouts-manage'])) {
            $rootScope.pushAlerts("Sorry, you have no permission to access this");
            $log.info("Permission error: required ['payouts-manage'], state: " + $state.current.name + ", function: publishersController");
            $state.go('index');
        }

        $scope.publishersPayoutsTable = this;
        $scope.publishersPayoutsTable.payouts = [];

        $scope.payoutsSearchQuery = '';

        $scope.filterPayoutsBy = {
            'ids': '',
            'payouts_ids': '',
            'status_id': '',
            'period_from': '',
            'period_to': '',
        };

        $scope.publishersPayoutsTable.dtOptions = {
            order: [],
            dom: 'tr',
        };

        $scope.publishersPayoutsTable.dtColumnDefs = [
            // Columns starting at 0
            DTColumnDefBuilder.newColumnDef(9).notSortable()
        ];

        $scope.publishersPayoutsStatuses = {};

        $scope.amount_to_pay = null;
        $scope.amount_paid = null;
        $scope.period = null;

        var userRoles = [];

        /*dbData.get('api/roles').then(
            function (response) {
                for (var i = 0; i < response.data.length; i++) {
                    userRoles.push(
                        {
                            id: response.data[i].id,
                            code: response.data[i].name,
                            display_name: response.data[i].display_name
                        }
                    );
                }
            }, function (error) {
                if (error.data.hasOwnProperty("error")) {
                    $rootScope.pushAlerts("Error : " + error.data.error);
                } else {
                    $rootScope.pushAlerts("Error while loading roles");
                }
                $log.error("An error occurred: " + error);
                $('.page-loading').addClass('hidden');
        });*/

        var getSumToPayAndPaid = function () {
            return dbData.get('api/publisher-payouts/sum-to-pay-and-paid').then(
                function (response) {
                    $scope.amount_to_pay = response.data.amount_to_pay !== undefined ? response.data.amount_to_pay : null;
                    $scope.amount_paid = response.data.amount_paid !== undefined ? response.data.amount_paid : null;
                    $scope.period = response.data.period !== undefined ? response.data.period : null;
                },
                function (error) {
                    $rootScope.pushAlerts("Error while loading Payout sums to pay / paid");
                }
            )
        }

        getSumToPayAndPaid();


        $scope.canApprove = function (approvalType) {

            if (approvalType === "fc") {
                return ($rootScope.user.roles.includes("financial-controller")) && !$rootScope.user.roles.includes("key-publisher-manager");
            }

            if (approvalType === "kpm") {
                return $rootScope.user.roles.includes("key-publisher-manager");
            }

            return false;
        }

        /**
         * Get list of publishers
         * @param page {number} page to be fetched
         */
        var getPublishersPayouts = function (page) {
            var page = page || 1;

            generatePayoutsSearchQuery();

            setTimeout(function () {
                // Clear table on every pagination roll
                $scope.publishersPayoutsTable.payouts = [];

                var endpoint = ($scope.payoutsSearchQuery) ? '/api/publisher-payouts' + $scope.payoutsSearchQuery + '&page=' + page : '/api/publisher-payouts' + '?page=' + page;

                dbData.get(endpoint).then(
                    function (response) {
                        $scope.publishersPayoutsTable.payouts = response.data.data;

                        if (response.data.total > response.data.per_page) {
                            generatePayoutsPagination(response.data.total, response.data.per_page, response.data.current_page, '/api/publisher-payouts');
                            $('#pagination').show();
                        } else {
                            $('#pagination').hide();
                        }
                    },
                    function (error) {
                        $('.page-loading').addClass('hidden');
                        if (error.data.hasOwnProperty("error")) {
                            $rootScope.pushAlerts("Error : " + error.data.error);
                        } else {
                            $rootScope.pushAlerts("Error while loading Publishers Payouts");
                        }
                        $log.error("An error has occurred: " + error);
                    }
                );
            }, 0);
        };

        var getPayoutStatuses = function () {
            return dbData.get('/api/payout-statuses').then(
                function (response) {
                    angular.forEach(response.data, function (item, index) {
                        $scope.publishersPayoutsStatuses[item.id] = { name: item.name, key: item.key };
                    });
                },
                function (error) {
                    $('.page-loading').addClass('hidden');
                    if (error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error : " + error.data.error);
                    } else {
                        $rootScope.pushAlerts("Error while loading Payout Statuses");
                    }
                    $log.error("An error has occurred: " + error);
                }
            );
        };
        // payouts depend on statuses
        getPayoutStatuses().then(getPublishersPayouts);

        /**
         * Generate payouts pagination
         * @param totalItems {number} total items in set
         * @param itemsPerPage {number} items displayed per page
         * @param page {number} page to be fetched
         * @param url {string}
         * @returns {undefined}
         */

        function generatePayoutsPagination(totalItems, itemsPerPage, page, url) {

            if (totalItems > itemsPerPage) {
                $('#pagination').pagination({
                    items: totalItems,
                    itemsOnPage: itemsPerPage,
                    pages: Math.ceil(totalItems / itemsPerPage),
                    cssStyle: 'light-theme',
                    currentPage: page,
                    hrefTextPrefix: url + "?page=",
                    onPageClick: function (pageNumber, e) {
                        e.preventDefault();
                        getPublishersPayouts(pageNumber);
                    }
                });
            }

            return undefined;
        }

        $scope.getPaymentDocument = function (index, payoutId) {
            $http.get('/api/publisher-payouts/' + payoutId + '/document', { responseType: 'blob' }).then(
                function (response) {
                    var contentDispositionHeader = response.headers('Content-Disposition');
                    var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
                    var url = window.URL.createObjectURL(new Blob([response.data]));
                    var link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", result.replace(/"/g, ''));
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                },
                function (error) {
                    if (!error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error while performing action on Payouts");
                    }
                    $log.error("An error has occurred: " + error);
                }
            );
        };

        $scope.performPayoutAction = function (index, payoutId, actionToPerform) {
            var endpoint = '',
                message = '';

            switch (actionToPerform) {
                case "approve-payout":
                    endpoint = '/api/publisher-payouts/' + payoutId + '/approve';
                    message = "Payout [" + payoutId + "] Approved";
                    break;

                case "decline-payout":
                    endpoint = '/api/publisher-payouts/' + payoutId + '/decline';
                    message = "Payout [" + payoutId + "] Declined";
                    break;

                case "recalculate-payout":
                    endpoint = '/api/publisher-payouts/' + payoutId + '/recalculate';
                    message = "Payout [" + payoutId + "] Recalculated";
                    break;

                case "confirm-manual-payout":
                    endpoint = '/api/publisher-payouts/' + payoutId + '/confirm-manual-payout';
                    message = "Manual Payout Confirmed for payout id: " + payoutId;
                    break;
            }

            dbData.put(endpoint).then(
                function (response) {
                    $rootScope.pushAlerts(message);
                    $scope.publishersPayoutsTable.payouts[index] = response.data;
                    getSumToPayAndPaid();
                },
                function (error) {
                    if (!error.data.hasOwnProperty("error")) {
                        $rootScope.pushAlerts("Error while performing action on Payouts");
                    }
                    $log.error("An error has occurred: " + error);
                }
            );
        };

        /*  on passing the approval we check if current user has a role of kpm or fc
            and if that is the case, we filter approvals to see if this user has already approved the payout */
        $scope.checkApprovals = function (approvals) {
            return (approvals.filter(function (approval) {
                if ($rootScope.user.roles.includes("key-publisher-manager")) {
                    return (approval.role_code === "key-publisher-manager");
                }

                if ($rootScope.user.roles.includes("financial-controller") && !$rootScope.user.roles.includes("key-publisher-manager")) {
                    return (approval.role_code === "financial-controller")
                }

            }).length) ? false : true
        };

        $scope.highlightPayouts = function (previous, current) {
            if (previous) {
                // if current > previous - percentage increase
                // if current < previous - percentage decrease

                var percentage = Math.round(((current - previous) / previous) * 100);

                if (percentage < -10) {
                    return ["highlight-decrease", percentage + "%"];
                }

                if (percentage > 10) {
                    return ["highlight-increase", "+" + percentage + "%"];
                }
            }
        };

        $(document).ready(function () {
            $('body').on('change', '#search_by_period_from', function (e) {
                $('#search_by_period_to').attr('min', $(this).val());
            });
        });

        /**
         * Generate payouts table search query for the filters
         */
        function generatePayoutsSearchQuery() {
            setTimeout(function () {

                // Reset search query
                $scope.payoutsSearchQuery = '';

                for (var property in $scope.filterPayoutsBy) {
                    switch (property) {
                        case "ids":
                            angular.forEach($scope.filterPayoutsBy.ids.trim().split(","), function (value, key) {
                                if (value !== "") {
                                    $scope.payoutsSearchQuery += "&publisher_ids[]=" + value;
                                }
                            });
                            break;
                        case "payouts_ids":
                            angular.forEach($scope.filterPayoutsBy.payouts_ids.trim().split(","), function (value, key) {
                                if (value !== "") {
                                    $scope.payoutsSearchQuery += "&ids[]=" + value;
                                }
                            });
                            break;
                        case "status_id":
                            if ($scope.filterPayoutsBy[property]) {
                                $scope.payoutsSearchQuery += '&status_id=' + $scope.filterPayoutsBy[property];
                            }

                            break;
                        case "period_from":
                            if ($scope.filterPayoutsBy[property]) {
                                $scope.payoutsSearchQuery += '&period_from=' + $scope.filterPayoutsBy[property].toISOString().slice(0, 10);
                            }
                            break;
                        case "period_to":
                            if ($scope.filterPayoutsBy[property]) {
                                $scope.payoutsSearchQuery += '&period_to=' + $scope.filterPayoutsBy[property].toISOString().slice(0, 10);
                            }
                            break;
                    }
                }

                // Replace first & with ?
                $scope.payoutsSearchQuery = $scope.payoutsSearchQuery.replace("&", "?");

            }, 0);
        };

        // Save filters data to local storage
        $('body').on('keyup', 'input#search_by_ids, input#search_by_payouts_ids', function () {
            $debounce(debounceKeyup, 500, false);
        });

        var debounceKeyup = function () {
            if ($('input#search_by_ids')[0].value.length >= 0) {
                $scope.filterPayoutsBy.ids = $('input#search_by_ids')[0].value;
            }

            if ($('input#search_by_payouts_ids')[0].value.length >= 0) {
                $scope.filterPayoutsBy.payouts_ids = $('input#search_by_payouts_ids')[0].value;
            }
            // Make a call
            getPublishersPayouts();
        };

        $scope.triggerDebouncedFilterById = function (filterElementId) {
            setTimeout(function () {
                switch (filterElementId) {
                    case "payout_search_by_status":
                        if ($('#payout_search_by_status').val()) {
                            $scope.filterPayoutsBy.status_id = $('#payout_search_by_status').val();
                        }
                        break;

                    case "search_by_period_from":
                        if ($('#search_by_period_from').val()) {
                            $scope.filterPayoutsBy.period_from = new Date($('#search_by_period_from').val());
                        }
                        break;

                    case "search_by_period_to":
                        if ($('#search_by_period_to').val()) {
                            $scope.filterPayoutsBy.period_to = new Date($('#search_by_period_to').val());
                        }
                        break;
                }
                // refresh table
                getPublishersPayouts();
            }, 100);
        };

        // Clear filters when input cross is pressed
        $('body').on('search', '.search-filters--publishers-payouts > .input-box input', function () {
            if ($(this)[0].id === 'search_by_ids') {
                $scope.filterPayoutsBy.ids = '';
            }
            // Make a call
            getPublishersPayouts(1);
        });
        $scope.$on('$destroy', function () {
            $('body').off('search', '.search-filters--publishers-payouts > .input-box input');
        });
    }
}]);